module.exports = __webpack_public_path__ + "media/images/cameraIcon-5ec05acc.png";